<template>
  <div id="app">
    <div class="flow">
      <img  @click="routerChange('http://www.supergame.one/forum.php?mod=viewthread&tid=1131')" class="gameImg"
      src="./assets/images/247x102.png" alt="">
      <img  @click="routerChange('http://www.supergame.one/forum.php?mod=viewthread&tid=1131')" class="nnn" src="./assets/images/247x75.png" alt="">
    </div>
    <div class="topVideo">
      <div class="logo">
        <img class="logo" src="./assets/images/news/logo.png" alt="" />
        <div class="link">
          <div class="fb">
            <img
              @click="routerChange('https://www.facebook.com/teg08168')"
              class="light"
              src="./assets/images/news/fbh.png"
              alt=""
            />
            <img
              @click="routerChange('https://www.facebook.com/teg08168')"
              class="dark"
              src="./assets/images/news/fb.png"
              alt=""
            />
          </div>
          <div class="line">
            <img
              @click="routerChange('https://line.me/R/ti/p/%40455nnfpu')"
              class="light"
              src="./assets/images/news/lineh.png"
              alt=""
            />
            <img
              @click="routerChange('https://line.me/R/ti/p/%40455nnfpu')"
              class="dark"
              src="./assets/images/news/line.png"
              alt=""
            />
          </div>
          <div class="line">
            <img
              @click="routerChange('https://supergame.one/')"
              class="light"
              src="./assets/images/news/homeh.png"
              alt=""
            />
            <img
              @click="routerChange('https://supergame.one/')"
              class="dark"
              src="./assets/images/news/home.png"
              alt=""
            />
          </div>
          <div class="line muted" v-if="btn">
            <img @click="openMuted" class="light" src="./assets/images/news/ismutedh.png" alt="" />
            <img @click="openMuted" class="dark" src="./assets/images/news/ismuted.png" alt="" />
          </div>
          <div class="line muted" v-else>
            <img @click="openMuted" class="light" src="./assets/images/news/mutedh.png" alt="" />
            <img @click="openMuted" class="dark" src="./assets/images/news/muted.png" alt="" />
          </div>
        </div>
      </div>
      <div class="loginLogo">
        <img src="./assets/images/news/loginLogo.png" alt="" />
      </div>
      <video-player
        class="video-player-box"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        customEventName="customstatechangedeventname"
        @loadeddata="onPlayerLoadeddata($event)"
        @playing="onPlayerPlaying($event)"
        @ended="onPlayerEnded($event)"
        @pause="onPlayerPause($event)"
        @statechanged="playerStateChanged($event)"
      >
      </video-player>
    </div>
    <div class="content">
      <div class="form">
        <div class="isLogin">
          <img src="./assets/images/news/count.png" alt="" />
          <p class="count">{{ count }}</p>
        </div>
        <div class="step firstStep">
          <img src="./assets/images/news/step-1-01.png" alt="" />
          <p>輸入手機號與LINE ID</p>
        </div>
        <div class="phone">
          <input type="text" v-model="phone" placeholder="請輸入電話號碼" />
        </div>
        <div class="phone">
          <input type="text" v-model="line" placeholder="LINE ID" />
        </div>
        <div class="info">
          <label class="checkbox-label">
            <input
              type="checkbox"
              v-model="check"
              autocomplete="false"
              name="marting"
              data-code="2"
            />
            <div class="checkbox-actual"></div>
            本人同意使用隱私政策及接收活動資訊
          </label>
        </div>
        <button class="submitBtn" @click="postMeg">事前登錄申請</button>

        <div class="step">
          <img src="./assets/images/news/step-2-01.png" alt="" />
          <p>
            加入<img class="icon"
              @click="routerChange('https://line.me/R/ti/p/%40455nnfpu')"  src="./assets/images/news/lineL.png" alt="" />
            好友並留下您的LINE ID。
          </p>
        </div>
        <div class="step" style="padding-bottom:48px">
          <img src="./assets/images/news/step-3-01.png" alt="" />
          <p>等待小編把您加入官方LINE群才算成功登錄。</p>
        </div>
      </div>
      <div class="reward">
        <div class="isLogin">
          <img src="./assets/images/news/count.png" alt="" />
          <p class="count">{{ count }}</p>
        </div>
        <div class="bc">
          <img class="agterLogin" src="./assets/images/news/afterlogin.png" alt="" />
          <h3>搶先獲得新編年史獎勵</h3>
          <div class="img">
            <div class="rewardWrap">
              <img v-if="count >= 1000" src="./assets/images/news/reach.png" class="reach" alt="" />
              <img v-else src="./assets/images/news/not.png" class="reach" alt="" />
              <img src="./assets/images/news/1000.jpg" alt="" />
              <button class="info" @click="lookInfo">
                查看詳情
              </button>
              <p class="rewardContent"></p>
            </div>
            <div class="rewardWrap">
              <img v-if="count >= 3000" src="./assets/images/news/reach.png" class="reach" alt="" />
              <img v-else src="./assets/images/news/not.png" class="reach" alt="" />
              <img src="./assets/images/news/3000.jpg" alt="" />
              <button class="info" @click="lookInfo">
                查看詳情
              </button>
            </div>
            <div class="rewardWrap">
              <img v-if="count >= 5000" src="./assets/images/news/reach.png" class="reach" alt="" />
              <img v-else src="./assets/images/news/not.png" class="reach" alt="" />
              <img src="./assets/images/news/5000.jpg" alt="" />
              <button class="info" @click="lookInfo">
                查看詳情
              </button>
            </div>
          </div>
        </div>
        <div class="p1Wrap note">
          <img class="top" src="./assets/images/news/bordert.png" alt="" />
          <img class="bottom" src="./assets/images/news/bordert.png" alt="" />
          <img class="leftt" src="./assets/images/news/borderr.png" alt="" />
          <img class="leftb" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightt" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightb" src="./assets/images/news/borderr.png" alt="" />
          <img src="./assets/images/news/warning.png" alt="" class="title" />
          <p class="warning">
            玩家可以提前進行遊戲安裝程序，<br class="mBr" />並將遊戲更新至最新數據。
          </p>
          <p class="warning">開服當天將可以立即登錄遊戲領取獎勵。</p>
          <img src="./assets/images/news/warningT.jpg" alt="" class="mobileNote" />
        </div>
      </div>
    </div>
    <div class="award" ref="award">
      <div class="leftImg">
        <div class="p1">
          <img class="top" src="./assets/images/news/bordert.png" alt="" />
          <img class="bottom" src="./assets/images/news/bordert.png" alt="" />
          <img class="leftt" src="./assets/images/news/borderr.png" alt="" />
          <img class="leftb" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightt" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightb" src="./assets/images/news/borderr.png" alt="" />
          <div class="awardWrap">
            <div class="awardContent">
              <div class="countImg">
                <img class="" src="./assets/images/news/count1000.png" alt="" />
              </div>
              <div class="picList">
                <div class="awards">
                  <img src="./assets/images/news/reward1.png" alt="" />
                  <p class="green">綠娃娃</p>
                  <p class="green">( 小思克巴 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward2.png" alt="" />
                  <p class="blue">古代的雷雨之劍</p>
                  <p class="blue">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward3.png" alt="" />
                  <p class="blue">弒神者之弓</p>
                  <p class="blue">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward4.png" alt="" />
                  <p class="blue">炎魔雙手劍</p>
                  <p class="blue">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward5.png" alt="" />
                  <p class="blue">隱藏的魔族手杖</p>
                  <p class="blue">( 刻印 )</p>
                </div>
              </div>
            </div>
            <div class="awardList">
              <div class="left">
                <p>金幣 * 300000</p>
                <p>騎士團貨幣 * 300000</p>
                <p>龍之珍珠 * 30</p>
                <p>龍之鑽石 * 50</p>
                <p>經驗加倍水 150% * 10</p>
              </div>
              <div class="right">
                <p class="title">限時娃娃 ( 7天 )</p>
                <p class="green">綠娃娃【 小司克巴 】</p>
                <p class="title">限時武器 ( 7天 )</p>
                <p class="blue">王族:古代的雷雨之劍 ( 刻印 )</p>
                <p class="blue">妖精:古代的雷雨之劍 ( 刻印 ) / 弒神者之弓 ( 刻印 )</p>
                <p class="blue">騎士:炎魔雙手劍 ( 刻印 )</p>
                <p class="blue">法師:隱藏的魔族手杖 ( 刻印 )</p>
              </div>
            </div>
          </div>
        </div>
        <div class="p1">
          <img class="top" src="./assets/images/news/bordert.png" alt="" />
          <img class="bottom" src="./assets/images/news/bordert.png" alt="" />
          <img class="leftt" src="./assets/images/news/borderr.png" alt="" />
          <img class="leftb" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightt" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightb" src="./assets/images/news/borderr.png" alt="" />
          <div class="awardWrap">
            <div class="awardContent">
              <div class="countImg">
                <img class="" src="./assets/images/news/count3000.png" alt="" />
              </div>
              <div class="picList">
                <div class="awards">
                  <img src="./assets/images/news/reward6.png" alt="" />
                  <p class="blue">藍娃娃</p>
                  <p class="blue">( 阿魯巴 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward7.png" alt="" />
                  <p class="red">惡魔王之劍</p>
                  <p class="red">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward8.png" alt="" />
                  <p class="red">惡魔王弓</p>
                  <p class="red">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward9.png" alt="" />
                  <p class="red">惡魔王的雙手劍</p>
                  <p class="red">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward16.jpg" alt="" />
                  <p class="red">惡魔王魔杖</p>
                  <p class="red">( 刻印 )</p>
                </div>
              </div>
            </div>
            <div class="awardList">
              <div class="left">
                <p>金幣 * 500000</p>
                <p>騎士團貨幣 * 500000</p>
                <p>龍之珍珠 * 50</p>
                <p>龍之鑽石 * 100</p>
                <p>經驗加倍水150% * 20</p>
                <p>對武器施法的卷軸 * 5</p>
                <p>對盔甲施法的卷軸 * 5</p>
              </div>
              <div class="right">
                <p class="title">限時娃娃 ( 7天 )</p>
                <p class="blue">藍娃娃【 阿魯巴 】</p>
                <p class="title">限時武器 ( 7天 )</p>
                <p class="red">王族:惡魔王之劍 ( 刻印 )</p>
                <p class="red">妖精:古代的雷雨之劍 ( 刻印 ) / 惡魔王弓 ( 刻印 )</p>
                <p class="red">騎士:惡魔王的雙手劍 ( 刻印 )</p>
                <p class="red">法師:惡魔王魔杖 ( 刻印 )</p>
              </div>
            </div>
          </div>
        </div>
        <div class="p1">
          <img class="top" src="./assets/images/news/bordert.png" alt="" />
          <img class="bottom" src="./assets/images/news/bordert.png" alt="" />
          <img class="leftt" src="./assets/images/news/borderr.png" alt="" />
          <img class="leftb" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightt" src="./assets/images/news/borderr.png" alt="" />
          <img class="rightb" src="./assets/images/news/borderr.png" alt="" />
          <div class="awardWrap">
            <div class="awardContent">
              <div class="countImg">
                <img class="" src="./assets/images/news/count5000.png" alt="" />
              </div>
              <div class="picList lastList">
                <div class="awards">
                  <img src="./assets/images/news/reward10.png" alt="" />
                  <p class="red">紅娃娃</p>
                  <p class="red">( 騎士范德 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward11.png" alt="" />
                  <p class="red">紅娃娃</p>
                  <p class="red">( 巫妖魔法娃娃 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward12.png" alt="" />
                  <p class="purple">克特之劍</p>
                  <p class="purple">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward13.png" alt="" />
                  <p class="purple">騎士范德之劍</p>
                  <p class="purple">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward14.png" alt="" />
                  <p class="purple">惡夢的長弓</p>
                  <p class="purple">( 刻印 )</p>
                </div>
                <div class="awards">
                  <img src="./assets/images/news/reward15.png" alt="" />
                  <p class="purple">傑羅斯的魔杖</p>
                  <p class="purple">( 刻印 )</p>
                </div>
              </div>
            </div>
            <div class="awardList">
              <div class="left">
                <p>金幣 * 1000000</p>
                <p>騎士團貨幣 * 1000000</p>
                <p>龍之珍珠 * 100</p>
                <p>龍之鑽石 * 200</p>
                <p>經驗加倍水150% * 30</p>
                <p>對武器施法的卷軸 * 10</p>
                <p>對盔甲施法的卷軸 * 10</p>
              </div>
              <div class="right last">
                <p class="title">限時娃娃 ( 7天 )</p>
                <p class="red">紅娃娃【 騎士范德法師 】【 巫妖魔法娃娃 】</p>
                <p class="title">限時武器 ( 7天 )</p>
                <p class="purple">王族:古代的雷雨之劍 ( 刻印 )</p>
                <p class="purple">妖精:古代的雷雨之劍 ( 刻印 ) / 弒神者之弓 ( 刻印 )</p>
                <p class="purple">騎士:炎魔雙手劍 ( 刻印 )</p>
                <p class="purple">法師:隱藏的魔族手杖 ( 刻印 )</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="leftImgM">
        <splide :options="options" class="slider">
          <splide-slide class="slideContent">
            <img class="a1" src="./assets/images/news/m1.png" alt="" />
          </splide-slide>
          <splide-slide class="slideContent">
            <img class="a2" src="./assets/images/news/m2.png" alt="" />
          </splide-slide>
          <splide-slide class="slideContent">
            <img class="a3" src="./assets/images/news/m3.png" alt="" />
          </splide-slide>
        </splide>
      </div>
    </div>

<div class="newWrap">
    <div class="new">
      <img class="title" src="./assets/images/news/newTitle.png" alt="">
      <div class="inside">
        <div class="left">
          <p class="step2">
            <img class="stepImg" src="./assets/images/news/step-1-01.png" alt="" />已參加事前登錄
          </p>
          <p class="step2">
            <img class="stepImg" src="./assets/images/news/step-2-01.png" alt="" />至
            <img class="icon"
              @click="routerChange('https://www.facebook.com/teg08168')" src="./assets/images/news/fbL.png" alt="" />按讚
          </p>
          <p class="step2 step3">
            <img class="stepImg" src="./assets/images/news/step-3-01.png" alt="" />
            至置頂文留言『快一起加入吧』並標註五位好友</p>
          <p class="step2">
            <img class="stepImg"  src="./assets/images/news/step-4-01.png" alt="" />截圖至
            <img class="icon"
              @click="routerChange('https://line.me/R/ti/p/%40455nnfpu')"  src="./assets/images/news/lineL.png" alt="" />等待審核通過
          </p>
        </div>
        <img class="like" src="./assets/images/news/like.png" alt="">
        <div class="newContent">
          <div class="inWrap">
            <div class="in">
              <p>金幣 * 200,000</p>
              <p>騎士團貨幣 * 200,000</p>
              <p>龍之珍珠 * 10</p>
              <p>龍之鑽石 * 30</p>
            </div>
            <div class="in">
              <p>經驗加倍水150% * 5</p>
              <p>對武器施法的卷軸 * 3</p>
              <p>對盔甲施法的卷軸 * 3</p>
              <p>地靈耳環 * 1</p>
            </div>
          </div>
          <img class="ear" src="./assets/images/news/ear.png" alt="">
        </div>
        <img class="ear2" src="./assets/images/news/ear.png" alt="">
      </div>
    </div>
</div>
    <div class="footerInfo">
      <img src="./assets/images/news/footerInfo.png" alt="" />
      <div class="wrap">
        <p class="title">活動時間：即日起至開服前一日23:59止</p>
        <p class="warning">1. 事前登錄活動每個手機號碼及LINE ID僅限預約一次。</p>
        <p class="warning">2. 活動獎勵將於開服後遊戲內發放。</p>
        <p class="warning">3. 若使用不正當手段參與事前登錄，官方將有權取消該玩家獲取獎勵資格。</p>
        <p class="warning">4. 本官方保留變更或終止活動之權利，若有變更內容將於活動內頁調正。</p>
      </div>
    </div>
    <div class="footer">
      <img src="./assets/images/15.png" alt="" />
      <div>
        <p>本遊戲情節涉及性、暴力、恐怖。</p>
        <p>注意使用時間，避免沈迷於遊戲，可能影響身心健康</p>
        <p>本遊戲部份內容或服務需另行支付其他費用。</p>
      </div>
    </div>
  </div>
</template>
<script>
import 'video.js/dist/video-js.css';

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'App',
  components: {
    Splide,
    SplideSlide,
    videoPlayer,
  },
  computed: {},
  data() {
    return {
      btn: true,
      check: true,
      // videojs options
      playerOptions: {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            // src: 'https://ncjapan2.nefficient.jp/ncjapan/ncsoft/lm/preview/video/bg_video.mp4',
            src: 'https://templin2021.s3-ap-northeast-1.amazonaws.com/topvideo.mp4',
          },
        ],
        poster: './assets/images/news/wait.jpg',
      },
      // screenWidth: 0,
      line: '',
      phone: '',
      count: '',
      options: {
        rewind: true,
        arrows: false,
        perPage: 1,
        width: '375px',
      },
    };
  },
  methods: {
    openMuted() {
      this.btn = !document.querySelector('.vjs-tech').muted;
      document.querySelector('.vjs-tech').muted = !document.querySelector('.vjs-tech').muted;
    },
    lookInfo() {
      this.$refs.award.scrollIntoView();
    },
    routerChange(link) {
      const mywin = window.open(link, link);
      const someCallback = function (url) {
        mywin.open(url, 'redirect');
      };
      someCallback(link);
    },
    onPlayerPlaying(player) {
      player.play().catch((e) => {
        console.log(e);
      });
    },
    onPlayerEnded(player) {
      player.play().catch((e) => {
        console.log(e);
      });
    },
    onPlayerPause(player) {
      player.play().catch((e) => {
        console.log(e);
      });
    },
    onPlayerLoadeddata(player) {
      player.play().catch((e) => {
        console.log(e);
      });
    },
    // ...player event
    postMeg() {
      if (!this.check) {
        this.$fire({
          title: '提醒',
          text: '請同意隱私政策及接收活動資訊!',
        });
        return;
      }
      if (!this.phone) {
        this.$fire({
          title: '提醒',
          text: '請輸入電話號碼!',
        });
        return;
      }
      if (!this.line) {
        this.$fire({
          title: '提醒',
          text: '請輸入LINE ID!',
        });
        return;
      }
      this.$http
        .post('/api/preRegist', {
          phone: this.phone,
          line: this.line,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.phone = '';
            this.line = '';
            this.$fire({
              title: '成功',
              text: '成功 !! 請繼續執行下列步驟',
            });
          } else {
            this.$fire({
              title: '提醒',
              text: res.data.message,
            });
          }
        });
    },
    getCount() {
      this.$http.get('/api/count').then((res) => {
        this.count = res.data.data;
      });
    },
    handleresize() {
      this.screenWidth = document.body.clientWidth;
      if (this.screenWidth >= 1080) {
        this.options.perPage = 5;
        this.options.fixedWidth = 190;
        this.options.width = 190 * 5 + 25;
      }
      if (this.screenWidth <= 1080 && this.screenWidth >= 768) {
        this.options.perPage = 4;
        this.options.fixedWidth = 150;
        this.options.width = 150 * 4 + 45;
      }
      if (this.screenWidth <= 768 && this.screenWidth >= 500) {
        this.options.perPage = 3;
        this.options.fixedWidth = 150;
        this.options.width = 150 * 3 + 45;
      }
      if (this.screenWidth <= 600) {
        this.options.perPage = 3;
        this.options.fixedWidth = 113;
        this.options.width = 113 * 3 + 15;
      }
      if (this.screenWidth === 375) {
        this.options.gap = '6px';
      }
    },
  },
  mounted() {
    // 获取跟随元素
    const flow = document.querySelector('.flow');
    // 进入页面广告距离页面上边距
    const originTop = flow.offsetTop;

    window.onscroll = function () {
      // 广告原始上边距 + 卷入高度
      flow.style.top = `${originTop + window.pageYOffset}px`;
    };
  },
  created() {
    // setInterval(() => {
    //   console.log('s');
    //   document.querySelector('.test').click();
    // }, 10000);
    this.getCount();
  },
};
</script>

<style lang="scss">
@import './style.scss';
* {
  scroll-behavior: smooth;
}
body {
  background-color: black;
  font-family: Georgia, 'Times New Roman', Times, serif;
}
#app {
  overflow-x: hidden;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.vjs-control-bar,
.video-js .vjs-big-play-button {
  opacity: 0;
}
.topBack {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('./assets/images/topbackPC.png');
}
@media (max-width: 768px) {
  #app {
    // background-image: url('./assets/images/mobileBack.jpg');
  }
}
.splide__track {
  // overflow: inherit;
}
h2 {
  font-size: 36px !important;
}
h3 {
  font-size: 16px !important;
}
h2,
h3 {
  color: white;
}
@media (max-width: 768px) {
  h2 {
    font-size: 30px !important;
  }
  h3 {
    font-size: 14px !important;
  }
}
.top {
  display: flex;
  justify-content: center;
  height: 150px;
  .logo {
    height: 100%;
    // width: auto;
  }
}
@media (max-width: 768px) {
  .top {
    height: 65px;
    .logo {
      // height: auto;
      // width: auto;
    }
  }
}
// .content{
//   position: relative;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   z-index: 99;
//   background-color: #A54105;
//   opacity: .7;
//   padding-top: 60px;
//   h3 {
//     margin: 22px 0 0 0;
//   }
//   img{
//     width: 100%;
//   }
// }
// .content {
//   padding-top: 30px;
// }
.splide__pagination {
  bottom: 2em;
}
.slider {
  // height: 190px;
  .slideContent {
    position: relative;
    .msg {
      position: absolute;
      bottom: 23px;
      color: white;
      text-align: center;
      width: 100%;
      font-size: 14px;
      line-height: 1.3;
    }
    .reach {
      position: absolute;
      right: 0;
      top: -20px;
      width: 80px;
    }
  }
}
@media (max-width: 1024px) {
  .slider {
    .slideContent {
      .reach {
        width: 65px;
        right: -10px;
        top: -15px;
      }
    }
  }
}
@media (max-width: 600px) {
  .slider {
    .slideContent {
      .reach {
        width: 50px;
        top: -10px;
      }
    }
  }
}
@media (max-width: 768px) {
  .content {
    h3 {
      margin-top: 12px;
    }
  }
  .slider {
    .slideContent {
      .msg {
        font-size: 12px;
        // bottom: 20px;
      }
    }
  }
}
.splide {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.splide__pagination__page.is-active {
  background-color: #fff;
}
.splide__pagination__page {
  background-color: rgb(90, 38, 12);
}
.content {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  flex-wrap: wrap;
  min-height: 100vh;
  background-image: url('./assets/images/news/contentBack.png');
}
.form {
  display: flex;
  justify-content: center;
  // align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  .submitBtn {
    max-width: 595px;
    width: 100%;
    background-color: #464660;
    color: #969696;
    font-size: 24px;
    border: none;
    outline: none;
    height: 78px;
    margin-bottom: 35px;
    color: white;
    &:hover {
      background-color: #64647d;
    }
  }
  .phone {
    height: 73px;
    max-width: 595px;
    margin-bottom: 15px;
    width: 100%;
    border: none;
    background-color: rgba(white, 0.4);
    color: #c8c8c8;
    display: flex;
    align-items: center;
    border-radius: 3px;
    font-size: 18px;
    ::placeholder {
      color: #c8c8c8;
    }
    select {
      background-color: transparent;
      border: none;
      outline: none;
      height: 100%;
      color: #823718;
    }
    input {
      background-color: transparent;
      border: none;
      outline: none;
      height: 100%;
      padding: 10px;
      color: white;
      font-size: 18px;
      width: 100%;
    }
  }
  .info {
    max-width: 595px;
    width: 100%;
    color: white;
    margin-top: 37px;
    margin-bottom: 30px;
    font-size: 16px;
    label {
      margin-left: 5px;
    }
    .checkbox-group .checkbox-label {
      display: inline-block;
      width: 156px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .checkbox-label {
      display: flex;
      align-items: center;
    }
    .checkbox-actual {
      position: relative;
      display: inline-block;
      margin: 4px 0 0 -28px;
      height: 20px;
      width: 20px;
      border: 1px solid white;
      background-color: #fff;
      vertical-align: text-bottom;
      margin-right: 5px;
    }

    .checkbox-label input[type='checkbox'] {
      visibility: hidden;
      width: 19px;
      height: 19px;
      display: inline-block;
    }

    .checkbox-ie8 input[type='checkbox'] {
      visibility: visible;
    }

    .checkbox-ie8 input[type='checkbox'] + .checkbox-actual:after {
      border: none;
    }

    .checkbox-ie8 .checkbox-actual {
      border: none;
    }

    input[type='checkbox']:checked + .checkbox-actual {
      border-color: white;
      // background-color: transparent;
    }
    input[type='checkbox']:checked + .checkbox-actual:after {
      opacity: 1;
    }
    input[type='checkbox'] + .checkbox-actual:after {
      content: '';
      width: 12px;
      height: 8px;
      position: absolute;
      top: 3px;
      left: 3px;
      border: 2px solid black;
      border-top: none;
      border-right: none;
      opacity: 0;
      transform: rotate(-45deg);
    }
    .checkbox-actual {
      background-color: #fff;
    }
    .checkbox-label.active {
      // color: black;
      background-color: #fff;
    }
  }
}

@media (max-width: 768px) {
  .form .info label {
    margin-left: 9px;
  }
  .form {
    margin-top: 35px;
    .phone {
      height: 55px;
      input {
        font-size: 13px;
      }
    }
    .info {
      margin-top: 16px;
      margin-bottom: 20px;
      label {
        font-size: 13px;
      }
    }
  }
  .form {
    .submitBtn {
      height: 51px;
    }
  }
}
@media (max-width: 425px) {
  .splide__pagination {
    bottom: 3em;
  }
}
.reward {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  .noteTitle {
    color: white;
    font-size: 20px;
    margin-bottom: 16px;
  }
  .warning {
    // color:#CBA33C;
    font-size: 14px;
    line-height: 2;
    max-width: 595px;
  }
}
.note {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  // background-image: url('./assets/images/bottombackPC.png');
  .noteTitle {
    color: white;
    font-size: 20px;
    margin-bottom: 16px;
  }
  .warning {
    // color:#CBA33C;
    // font-size: 14px;
    line-height: 2;
  }
}
@media (max-width: 768px) {
  .note {
    // background-image: url('./assets/images/bottomback.png');
  }
  .note,
  .reward {
    .noteTitle {
      font-size: 18px;
    }
    .warning {
      font-size: 13px;
    }
  }
}
.footer {
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
  }
  img {
    width: 50px;
    height: 50px;
  }
  p {
    color: #646464;
    font-size: 12px;
    width: 100%;
    line-height: 1.3;
  }
}
@media (max-width: 768px) {
  .footer {
    height: 90px;
  }
}
</style>
